// Theme management — 8 official palettes with distinct typography per theme.
// Each palette also drives font-family via CSS variables (--font-body, --font-display).
const KEY = "ovamx:theme";

export const THEMES = [
  {
    id: "arctic",
    name: "Arctic Mist",
    sub: "Oficial · limpio y tecnológico",
    swatch: "#7FA9D6",
    bg: "#F0F5FA",
    ink: "#0E1626",
    accent: "#7FA9D6",
    fontLabel: "Outfit + Cormorant",
  },
  {
    id: "slate",
    name: "Slate Blue",
    sub: "Editorial · destaca las fotos",
    swatch: "#3D5A80",
    bg: "#E8EDF2",
    ink: "#0F1B2D",
    accent: "#3D5A80",
    fontLabel: "Outfit + Cormorant",
  },
  {
    id: "ivory",
    name: "Soft Ivory",
    sub: "Cálido · concepto hogar",
    swatch: "#D4B996",
    bg: "#F5EFE6",
    ink: "#2A1F12",
    accent: "#D4B996",
    fontLabel: "Outfit + Cormorant",
  },
  {
    id: "ember",
    name: "Ember Coral",
    sub: "Atardecer · terracota vivo",
    swatch: "#E07A5F",
    bg: "#FBF3EE",
    ink: "#3D1F14",
    accent: "#E07A5F",
    fontLabel: "DM Sans + Playfair",
  },
  {
    id: "forest",
    name: "Forest Green",
    sub: "Naturaleza · verde profundo",
    swatch: "#3B6B4B",
    bg: "#EDF2EC",
    ink: "#0F2415",
    accent: "#3B6B4B",
    fontLabel: "Inter + Fraunces",
  },
  {
    id: "sakura",
    name: "Sakura Pink",
    sub: "Primavera · rosa cerezo",
    swatch: "#D4879E",
    bg: "#FBF0F3",
    ink: "#3B1C24",
    accent: "#D4879E",
    fontLabel: "Manrope + Cormorant",
  },
  {
    id: "midnight",
    name: "Midnight Neon",
    sub: "Nocturno · azul eléctrico",
    swatch: "#4A9EFF",
    bg: "#0A1220",
    ink: "#E8F0FF",
    accent: "#4A9EFF",
    fontLabel: "Space Grotesk",
    dark: true,
  },
  {
    id: "sepia",
    name: "Sepia Journal",
    sub: "Vintage · periódico antiguo",
    swatch: "#8B6F47",
    bg: "#F4EBD7",
    ink: "#2E1F0F",
    accent: "#8B6F47",
    fontLabel: "Lora + Playfair",
  },
];

export const getStoredTheme = () => {
  try {
    const v = localStorage.getItem(KEY);
    return THEMES.find((t) => t.id === v) ? v : "arctic";
  } catch { return "arctic"; }
};

export const setTheme = (id) => {
  const root = document.documentElement;
  root.setAttribute("data-theme", id);
  try { localStorage.setItem(KEY, id); } catch { /* noop */ }
};

export const initTheme = () => setTheme(getStoredTheme());
